module.exports = __webpack_public_path__ + "img/vue2-arriere_lavande.e9c40054.png";